<style scoped>
    .customer{
        position: relative;
        display: inline-block;
        vertical-align: top;
        width: 450px;
        border: 1px solid #dddee1;
        padding: 10px 10px 10px 0;
        margin: 2px;
        text-align: left;
        background: white;
        transition: .4s;
        font-size: 12px;
    }
    .customer:hover{
        box-shadow: 0 3px 5px rgba(55,55,55,.3);
    }
    .quit-status{
        display: inline-block;
        position: absolute;
        top: 5px;
        left: 5px;
        width: 8px;
        height: 8px;
        line-height: 8px;
    }
    .quit-status-text{
        display: inline-block;
        width: 36px;
        text-align: center;
    }
    .quit-status-dot{
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 4px;
        cursor: pointer;
    }
    .quit-status-dot:hover{
        transform: scale(1.4,1.4);
    }
    .quit-status-dot.in{
        background: #19be6b;
    }
    .quit-status-dot.in:hover{
        background: #19a06b;
    }
    .quit-status-dot.off{
        background: #ed3f14;
    }
    .quit-status-dot.off:hover{
        background: #c93f14;
    }
    .base-info{
        position: relative;
        min-height: 170px;
    }
    .base-info-left{
        display: inline-block;
        width: 40%;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        border-right: 1px solid #dddee1;
    }
    .avatar{
        display: inline-block;
        width: 140px;
        height: 140px;
        border-radius: 50%;
        border: 1px solid #dddee1;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        overflow: hidden;
        text-align: center;
        color: #dddee1;
    }
    .avatar img{
        width: 100%;
        height: 100%;
    }
    .avatar-exist{
        /* cursor: pointer; */
        border-color: white;
        transition: .3s;
    }
    /* .avatar-exist:hover{
        width: 180px;
        height: 180px;
    } */
    .base-info-right{
        display: inline-block;
        text-align: left;
        padding-left: 185px;
    }
    .tag{
        position: absolute;
        top: -5px;
        left: 30px;
        font-size: 16px;
    }
    .links{
        position: absolute;
        top: -5px;
        right: 10px;
        font-size: 16px;
    }
    .name{
        font-size: 24px;
        font-weight: bold;
    }
    .nickname{
        margin-left: 5px;
        font-size: 14px;
    }
    .contact-line{
        position: relative;
        clear: both;
    }
    .contact-item{
        display: inline-block;
        vertical-align: top;
    }
    .contact-label{
        position: absolute;
        left: 0;
        top: 0;
        width: 60px;
        text-align: left;
    }
    .contact-gap{
        position: absolute;
        left: 65px;
        top: 0;
    }
    .contact-value{
        padding-left: 73px;
    }
    .item-link{
        color: #2d8cf0;
        cursor: pointer;
    }
    .item-link:hover{
        color: #2b85e4;
        text-decoration: underline;
    }
</style>
<template>
    <div class="customer">
        <Tooltip transfer class="quit-status" placement="top">
            <span>
                <span class="quit-status-dot off" v-if="customer.quit"></span>
                <span class="quit-status-dot in" v-else></span>
            </span>
            <div class="quit-status-text" slot="content">
                <span v-if="customer.quit">已离职</span>
                <span v-else>在职</span>
            </div>
        </Tooltip>
        <div class="base-info">
            <div class="base-info-left">
                <div class="tag" v-if="false">
                    <Icon type="ios-football"></Icon>
                    <Icon type="ios-game-controller-b"></Icon>
                    <Icon type="headphone"></Icon>
                    <Icon type="videocamera"></Icon>
                </div>
                <div class="links" v-if="false">
                    <Icon type="social-github"></Icon>
                    <Icon type="social-twitter"></Icon>
                    <Icon type="social-facebook"></Icon>
                </div>
                <div class="avatar" :class="{'avatar-exist': customer.avatar}">
                    <img :src="avatarUrl(customer.avatar)" v-if="customer.avatar">
                    <Icon type="ios-person" size="126" v-else></Icon>
                </div>
            </div>
            <div class="base-info-right">
                <div class="account">
                    <span class="name">{{customer.account}}</span>
                    <span class="nickname" v-if="customer.nickname">昵称: {{customer.nickname}}</span>
                </div>
                <div class="contacts">
                    <div class="contact-line">
                        <span class="contact-item contact-label">性别</span>
                        <span class="contact-item contact-gap">:</span>
                        <span class="contact-item contact-value">
                            <span>{{customer.gender ? '男' : '女'}}</span>
                        </span>
                    </div>
                    <div class="contact-line">
                        <span class="contact-item contact-label">
                            <span>团队</span>
                            <span>/</span>
                            <span>岗位</span>
                        </span>
                        <span class="contact-item contact-gap">:</span>
                        <span class="contact-item contact-value">
                            <span v-if="customer.team">{{customer.team}}</span>
                            <span class="color-grey" v-else>未填写</span>
                            <span>/</span>
                            <span v-if="customer.job">{{customer.job}}</span>
                            <span class="color-grey" v-else>未填写</span>
                        </span>
                    </div>
                    <div class="contact-line">
                        <span class="contact-item contact-label">邮箱</span>
                        <span class="contact-item contact-gap">:</span>
                        <span class="contact-item contact-value">
                            <span v-if="customer.email">{{customer.email}}</span>
                            <span class="color-grey" v-else>未填写</span>
                        </span>
                    </div>
                    <div class="contact-line">
                        <span class="contact-item contact-label">手机</span>
                        <span class="contact-item contact-gap">:</span>
                        <span class="contact-item contact-value">
                            <span v-if="customer.mobile">{{customer.mobile}}</span>
                            <span class="color-grey" v-else>未填写</span>
                        </span>
                    </div>
                    <div class="contact-line">
                        <span class="contact-item contact-label">
                            <span>微信</span>
                            <span>/</span>
                            <span>QQ</span>
                        </span>
                        <span class="contact-item contact-gap">:</span>
                        <span class="contact-item contact-value">
                            <span v-if="customer.wechat_number">{{customer.wechat_number}}</span>
                            <span class="color-grey" v-else>未填写</span>
                            <span>/</span>
                            <span v-if="customer.qq_number">{{customer.qq_number}}</span>
                            <span class="color-grey" v-else>未填写</span>
                        </span>
                    </div>
                    <div class="contact-line">
                        <span class="contact-item contact-label">办公地点</span>
                        <span class="contact-item contact-gap">:</span>
                        <span class="contact-item contact-value">
                            <span class="item-link" v-if="customer.location" @click="showLocation">
                                {{customer.location.office_name}}
                                <Icon type="ios-pin"></Icon>
                            </span>
                            <span class="color-grey" v-else>未设置</span>
                        </span>
                    </div>
                    <div class="contact-line">
                        <span class="contact-item contact-label">兴趣爱好</span>
                        <span class="contact-item contact-gap">:</span>
                        <span class="contact-item contact-value">
                            <span style="margin-right: 5px" v-for="i in customer.interests">{{i.name}}</span>
                            <span class="color-grey" v-if="!customer.interests.length">未填写</span>
                        </span>
                    </div>
                    <div class="contact-line">
                        <span class="contact-item contact-label">个人主页</span>
                        <span class="contact-item contact-gap">:</span>
                        <span class="contact-item contact-value">
                            <a style="margin-right: 5px" :href="hp.page_url" target="_blank" v-for="hp in customer.home_pages">{{hp.name}}</a>
                            <span class="color-grey" v-if="!customer.home_pages.length">未填写</span>
                        </span>
                    </div>
                    <div class="contact-line" v-if="customer.customer_type >= 10">
                        <span class="contact-item contact-label">负责人</span>
                        <span class="contact-item contact-gap">:</span>
                        <span class="contact-item contact-value">
                            <span v-if="customer.director">{{customer.director}}</span>
                            <span class="color-grey" v-else>未设置</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <MapLocate v-if="map_locate_config.show" :customer_id="customer.id" :config="map_locate_config"></MapLocate>
    </div>
</template>
<script>
    import Util from '../../../libs/util';
    import MapLocate from '../office_map/locate';
    export default {
        components: { MapLocate },
        props: {
            customer: {
                type: Object
            }
        },
        data(){
            return {
                show_location: false,
                map_locate_config: {
                    show: false,
                    fixed: true
                }
            }
        },
        computed: {
            //
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            avatarUrl(avatar){
                return Util.avatarUrl(avatar);
            },
            showLocation(){
                this.map_locate_config.show = true;
            }
        }
    }
</script>
